import React from 'react'
import * as firebase from "firebase";
import Notifier from "react-desktop-notification"



export default class Chat extends React.Component {

    constructor(props) {
        super(props)
        this.checkSignedIn = this.checkSignedIn.bind(this)
        this.state = {convoID:"",value: '',isLoggedIn: false, userID:null,messages:[],chatRef:'',userIDs:[],convosIDsRef:'',convoIDs:[]};
        this.getMessages = this.getMessages.bind(this);
        this.renderChatBubble = this.renderChatBubble.bind(this);
        this.renderChatMessages = this.renderChatMessages.bind(this);
        this.sendMessage = this.sendMessage.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.scrollToBottom = this.scrollToBottom.bind(this);
        this.getConvos = this.getConvos.bind(this);
        this.renderConvoVeiw =this.renderConvoVeiw.bind(this);
        this.renderConvosVeiw = this.renderConvosVeiw.bind(this);
        this.changeChatConvID = this.changeChatConvID.bind(this);
        this.gotNewNotification = this.gotNewNotification.bind(this);
        this.notifactionListener = this.notifactionListener.bind(this);

    }

    componentWillMount() {
        this.checkSignedIn()
    }
    handleChange(event) {
        this.setState({value: event.target.value});
    }
    signOut(){
        console.log("signing user out");
        alert("signing out");
       firebase.auth().signOut().then(function() {
            // Sign-out successful.
        }).catch(function(error) {
            // An error happened.
        });

    }
    handleSignOut(){
        console.log("signing user out");
        alert("signing out");

    }
    checkSignedIn() {

        var state = this
        firebase.auth().onAuthStateChanged(function (user) {
            if (user) {
                console.log("singed in : " + user.phoneNumber);
                state.setState({isLoggedIn: true});
                state.setState({userID: user.phoneNumber.replace(/\D/g, '')});
                this.setState({convosIDsRef:'users/'+this.state.userID + '/convos/'});
               // state.getMessages()
                state.getConvos()
            } else {

                console.log("singed out  ");
                state.setState({isLoggedIn: false});
                window.location = '/#/';

            }
        }.bind(this));

    }
     getMessages(fireRef) {
         this.setState({chatRef:fireRef});
        if (this.state.isLoggedIn) {

            console.log("getting message");
            var chatRef = firebase.database().ref(fireRef).limitToLast(50);
            chatRef.on('child_added', function (data) {
                var message = data.val();
                this.setState({userIDs: message.userIDs});
                console.log(data.val());

                this.state.messages.push(data.val());
                this.setState({messages:this.state.messages});



            }.bind(this));
        }

    }

    getConvos(){

        if(this.state.isLoggedIn) {
            console.log("tried to get convo");

            var state = this;

            var convoRef = firebase.database().ref(this.state.convosIDsRef);
            convoRef.on('child_added', function (data) {
                var convoID = data.val();
                this.notifactionListener(convoID)
                console.log(convoID);
                var convoIDs = this.state.convoIDs;
                if(convoIDs.length==0){
                    this.changeChatConvID(convoID);
                }
                convoIDs.push(convoID);
                console.log(convoIDs)
                this.setState({convoIDs: convoIDs})
                console.log(state.state.convoIDs.length);
            }.bind(this));
        }
    }

    handleSubmit( event) {

        if(this.state.value != ''){
            this.sendMessage(this.state.value)
            this.setState({value: ''});        }


    }
    sendMessage(message){
       var newPostRef = firebase.database().ref(this.state.chatRef).push();
       var messageObj = {fromUserID:this.state.userID,message:message,mid:newPostRef.key,timeStamp:new Date().getTime(),userIDs:this.state.userIDs}
       var receiptObj = {isDelivered:false, isRead:false};
        firebase.database().ref('messages/' + newPostRef.key).set(receiptObj);
       console.log(messageObj)
       newPostRef.set(messageObj);
    }

    notifactionListener(convoID){
        if (this.state.isLoggedIn) {
            var chatRef = firebase.database().ref('convos/' + convoID + '/messageIds').limitToLast(1);
            chatRef.on('child_added', function (data) {
                var message = data.val();
                var receiptRef = firebase.database().ref('messages/' + data.key);
                receiptRef.once('value', function (data) {
                    var receipts = data.val();
                    if (message.fromUserID != this.state.userID && receipts.isDelivered != true && (document.hidden || document.msHidden || document.webkitHidden || document.mozHidden)) {
                        this.gotNewNotification(message.message,message.fromUserID)
                    }
                }.bind(this));

            }.bind(this));
        }

    }
    gotNewNotification(message, fromUser){

        //Here will pop a notifier and always open in a new window when clicked.
        Notifier.start("New Message:  " + fromUser,message,"https://www.texterapp.org/#/Chat/","/CircleIcon.png","Texter");

        //Here will pop notifier and open in a specified name window "popwin1" when clicked.
        //Notifier.start("Title","Here is context","www.google.com","validated image url","popwin1");
    }
    renderChatBubble(message){
        var from_class = "out_going"
        if(this.state.userID != message.fromUserID){
            from_class = "incoming"
        }

        return   <div className="message_wrapper">
            <div className="bubble"  id={from_class}>
                <p>{message.message}</p>

            </div>
        </div>

    }


    renderChatMessages(){
        console.log("messages length:" + this.state.messages.length);
        var state = this;
        var messagesSize = this.state.messages.length
        return this.state.messages.map(function ( message,i) { debugger;
        var bubble = state.renderChatBubble(message);
            if (messagesSize === i + 1) {
                // last one
                this.scrollToBottom;
               return <div>
                   {bubble}

                   <div id="spacer"></div>

               </div>;
            }else {
                return bubble;
            }
        }.bind(this))
    }
    changeChatConvID(convoID){

        if(this.state.chatRef != 'convos/'+convoID+'/messageIds') {
            console.log(convoID);
            console.log(this.state.chatRef);
            this.state.messages.splice(0, this.state.messages.length);
            this.setState({userIDs: []});
                try {
                    firebase.database().ref(this.state.chatRef).off();
                }catch(e) {

                }
                this.setState({convoID:convoID});
            this.getMessages('convos/' + convoID + '/messageIds');
        }



    }
    renderConvoVeiw(convoID){
        var convoCard = <div className="card" id="convo_card" onClick={()=>this.changeChatConvID(convoID)}>
                <div className="container">
                    <h4><b>Comming Soon</b></h4>
                    <p>{convoID}</p>
                </div>
        </div>;

        return convoCard;  //<div> <button onClick={()=>this.changeChatConvID(convoID)}>{convoID}</button></div>;

    }


    renderConvosVeiw(){

        var state = this;
        return this.state.convoIDs.map(function ( convoID) { debugger;

            return state.renderConvoVeiw(convoID);

        })
    }
scrollToBottom(){
    var id = "chat";
    var div = document.getElementById(id);
    if(div != null) {
        div.scrollTop = div.scrollHeight - div.clientHeight;
    }
}

    render() {

        const isLoggedIn = this.state.isLoggedIn;

        return <div id="content" className="card">
            <div id="chat_screen">
            <div id="convo_ids_section">
                <section >
                    {this.renderConvosVeiw()}
                </section>
            </div>
            <div id="chat_section">
                <div className="card" id="chat_title">{this.state.userIDs}</div>
            <div id="chat">
                <section >
                    {this.renderChatMessages()}
                    {this.scrollToBottom()}
                </section>
            </div>

                <form className="chat_box" action="javascript:void(-1)"  autoComplete="off" onSubmit={  () => this.handleSubmit()  }>
                    < input className="chat_box"  id="chat_text_box" type="text" value={this.state.value} name="fname" onChange={(this.handleChange)} />
                </form>
            </div>
            </div>

        </div>

    }


}






// WEBPACK FOOTER //
// ./src/components/pages/Chat.jsx